'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceInfo = getDeviceInfo;
exports.getDeviceFrames = getDeviceFrames;

var _devices = require('./devices.json');

var _devices2 = _interopRequireDefault(_devices);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var deviceFrames = Object.keys(_devices2.default);

function getDeviceInfo(frame) {
  var info = _devices2.default[frame];

  if (!info) {
    throw new Error('No such frame: ' + frame);
  }

  return info;
}

function getDeviceFrames() {
  return deviceFrames;
}

;